import { createFileRoute } from '@tanstack/react-router';

const Component = () => {
  return <div>Payments</div>;
};

export const Route = createFileRoute('/_auth/_layout/students/$studentId/payments')({
  component: Component,
});
